function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
jQuery('document').ready(function($){
  
  // Close Mobile Navigation Popup Data Outside Click
  $(document).on('click','.mobile_navig_active', function(e) {
    if($(e.target).closest(".mnavig_sec").length === 0 && $('.mobile_navig_sec').hasClass('mobile_navig_active')) {
      e.preventDefault();
      $('body').removeClass('u-scroll-disabled');
      $('.mobile_navig_sec').removeClass('mobile_navig_active');
    }
  });

  // Mobile Navigation Active Classes
  $('.header_icons_mobmenu').on('click','.mobile_menu_click', function(e){
    e.preventDefault();
    var announceheight = $('.header_announce').innerHeight();
    var headheight = $('.shopify-section-header').innerHeight();
    var totalheight = announceheight + headheight;
    var headoffset = $(window).scrollTop();
    if(headoffset > announceheight) {
      $('.mobile_navig_sec').css('top', headheight + 'px');
      $('.mnavig_sec').css('height', 'calc(100vh - '+ headheight +'px)');
    } else {
      var ttlheight = totalheight - headoffset;
      $('.mobile_navig_sec').css('top', ttlheight + 'px');
      $('.mnavig_sec').css('height', 'calc(100vh - '+ ttlheight +'px)');
    }
    $('body').toggleClass('u-scroll-disabled');
    $('.mobile_navig_sec').toggleClass('mobile_navig_active');
  });

  // Mobile Submenu Active Classes
  $('.mnavig_li').on('click','.has_submenu', function(e){
    e.preventDefault();
    $(this).siblings('.mnavig_subul').slideToggle('medium','linear');
  });
  
  // Submenu Active Classes
  $('drawer-menu .header_navig_ul').on('click','.has_submenu', function(e){
    e.preventDefault();
    $(this).siblings('ul').slideToggle('medium','linear');
  });
  
  // Read More Image Text
  $('.click_maincontent').on('click', function(e){
    e.preventDefault()
    if($(this).siblings('.imgtxt_mainpara').length > 0) {
      $(this).toggleClass('text_rev');
      $(this).siblings('.imgtxt_mainpara').slideToggle('medium','linear');
    }
  });
  
  //Newsletter Active
  $('.newsletter_click').on('click', function(e){
    e.preventDefault();
    $(this).addClass('disp_none');
    $(this).siblings('.newsletter_form').slideToggle('medium','linear');
  });

  // FAQ's Active Classes
  $('.faq_list').on('click','.faq_list_head', function(e){
    e.preventDefault();
    if($(this).parent('.faq_list').hasClass('faq_list_active')){
      $(this).parent('.faq_list').removeClass('faq_list_active');
      $(this).siblings('.faq_answer').slideToggle('medium','linear');
    } else {
      $(this).parent('.faq_list').addClass('faq_list_active');
      $(this).siblings('.faq_answer').slideToggle('medium','linear');
      $(this).parent('.faq_list').siblings('.faq_list_active').find('.faq_answer').slideToggle('medium','linear');
      $(this).parent('.faq_list').siblings('.faq_list_active').removeClass('faq_list_active');
    }
  });

  //Image Text Height
  if($('.imgtxt_height').length >= 1){
    setTimeout(function() { 
      $('.imgtxt_height').each(function(e) {
        var imgcol_height = $(this).find('.newsletter_form_box').innerHeight();
        var contcol_height = $(this).find('.imgtxt_content').innerHeight();
        if(contcol_height > imgcol_height){
          var height_diff = contcol_height - imgcol_height;
          
          if($(this).find('.imgtxt_para_box').length >= 1) {
            var imgtxt_para_height =  $(this).find('.imgtxt_para_box').innerHeight();
            imgtxt_para_height = imgtxt_para_height - height_diff;
            var actual_height = Math.floor(imgtxt_para_height / 26);
            actual_height = actual_height * 26;
            console.log(actual_height);
            $(this).find('.imgtxt_para_box').css('height', actual_height - 26 +'px');
            $(this).find('.imgtxt_para_box').after('<span class="readm_para">Read More...</span>');
          }
          if($(this).find('.imgtxt_img.match_imgheight').length >= 1) {
            $(this).find('.imgtxt_img.match_imgheight').css('height', height_diff+'px');
          }
        } else {
          if($(this).find('.imgtxt_img.match_imgheight').length >= 1) {
            $(this).find('.imgtxt_img.match_imgheight').css('height', imgcol_height+'px');
          }
        }
        console.log(contcol_height+' -> '+imgcol_height+' -> '+height_diff);
      });
    }, 2000);
  }

  // Read More Para
  $('.imgtxt_height').on('click','.readm_para', function(e){
    e.preventDefault();
    $(this).siblings('.imgtxt_para_box').addClass('imgtxt_para_height');
    $(this).hide();
  });

  // Read More Active
  $('.readmore_descript').on('click', function(e){
    e.preventDefault();
    $(this).parent('.prod_info_shortdescript').slideToggle('medium','linear');
    $('.prod_info_descript').slideToggle('medium','linear');
  });

  // Read Less Active
  $('.readless_descript').on('click', function(e){
    e.preventDefault();
    $(this).parent('.prod_info_descript').slideToggle('medium','linear');
    $('.prod_info_shortdescript').slideToggle('medium','linear');
  });

  //Swatch Title Change
  $('input[name="Flavour"]').on('change',function(){
    $('span#flavour_name').html($(this).val());
  });

  //Dropdown Swatch
  $('.product_swatch_head').on('click', function(e){
    e.preventDefault();
    if($(this).hasClass('product_swatch_active')){
      $(this).removeClass('product_swatch_active');
      $(this).siblings('.product-form_swatch_down').slideToggle('medium','linear');
    } else {
      $(this).addClass('product_swatch_active');
      $(this).siblings('.product-form_swatch_down').slideToggle('medium','linear');
    }
  });

  //Dropdown Swatch Close When Selected
  $('.product-form_swatch_box.product-form_swatch_down').on('change', 'input[name="Flavour"]', function(e){
    e.preventDefault();
      $(this).parents('.product-form_swatch_down').slideToggle('medium','linear');
      $(this).parents('.product-form_swatch_box').prev().removeClass('product_swatch_active');
  });

  //Dropdown Swatch Close When Click Outside
  $(document).mouseup(function(e) {
    var swatch_box = $(".product-form_swatch_box.product-form_swatch_down, .product_swatch_head");
    if (!swatch_box.is(e.target) && swatch_box.has(e.target).length === 0 && $('.product_swatch_head.product_swatch_active').length > 0) {
      $(".product-form_swatch_box.product-form_swatch_down").slideToggle('medium','linear');
      $(".product_swatch_head").removeClass('product_swatch_active');
    }
  });
  
  //PerUnit Price APPSTLE
  if($('body').hasClass('template-product') || $('body').hasClass('template-index')){
    var get_quantity = 0;
    if($('.swatch_pack_size').length >= 1){
      var price_quantity = parseInt($('.swatch_pack_size input[type="radio"]:checked').val());
    } else if($('.swatch_pack').length >= 1){
      var price_quantity = parseInt($('.swatch_pack input[type="radio"]:checked').val());
    } else {
      if($('.prod_perunit').length >= 1) {
        get_quantity = parseFloat($('.prod_perunit').text()).toFixed(2);
      }
      var price_quantity = 1;
    }
    if($('.prod_hide_unit').text() != '') {
      var unit_text = $('.prod_hide_unit').text();
    } else {
      var unit_text = 'PER UNIT';
    }
    var price_unit = $('.prod_hide_currency').text();
    
    if($('#appstle-subscription-widget-placeholder').length >= 1 || $('.prod_info_apphom').length >= 1){
      let inter_val = setInterval(function () {
        if($(".appstle_subscription_wrapper_option").length >= 1) {
          $('.prod_info_price').addClass('disp_none');
          var price_box = $('.appstle_subscription_wrapper_option').not('.appstle_include_dropdown').find('.appstle_subscription_amount').text();
          price_box = price_box.replace(price_unit,'');
          if(get_quantity != 0) {
            price_quantity = parseFloat(price_box / get_quantity).toFixed(2);
          }
          var price_unitprice = parseFloat(price_box / price_quantity).toFixed(2) ;
          
          var price_subscript = $('.appstle_include_dropdown .appstle_subscription_amount').text();
          price_subscript = price_subscript.replace(price_unit,'');
          var price_subsunitprice = parseFloat(price_subscript / price_quantity).toFixed(2) ;
          $(".appstle_subscription_wrapper_option.appstle_include_dropdown").append('<ul class="appstle_lists"><li>Save 25% off your first order & 15% thereafter</li><li>Easily pause, swap or skip</li><li>Cancel quickly anytime</li><li>Daily ritual</li></ul>');
          $(".appstle_subscription_wrapper_option.appstle_include_dropdown").find('.appstle_subscription_amount_wrapper').append('<div class="appstle_perunit" data-price="'+price_subscript+'" data-quantity="'+price_quantity+'"><span>'+price_unit+''+price_subsunitprice+'</span>&nbsp;'+unit_text+'</div>');
          $(".appstle_subscription_wrapper_option").not('.appstle_include_dropdown').find('.appstle_one_time_price_wrapper').append('<div class="appstle_perunit" data-price="'+price_box+'" data-quantity="'+price_quantity+'"><span>'+price_unit+''+price_unitprice+'</span>&nbsp;'+unit_text+'</div>');
          clearInterval(inter_val);
        }
      }, 1000);
    }
  }

  //Swatch Change APPSTLE
  $('input[name="Pack Size"], input.product-form__swatch__input').on('change',function(){
    setTimeout(function () {
    var prevariantid = getParameterByName('variant');
    console.log(prevariantid);
    var available = $('select[name="prod_opt"] option[data-id="'+prevariantid+'"]').attr('data-available');
    var preorder = $('select[name="prod_opt"] option[data-id="'+prevariantid+'"]').attr('data-preorder');
    console.log(available+" - "+preorder);
    if(available == 'true' && preorder == 'true'){
      $('button[name="add"]').text('Pre Order');
      $('div.pre_order_message').text($('select[name="prod_opt"] option[data-id="'+prevariantid+'"]').attr('data-pomsg'));
    }
    if(available == 'true' && preorder != 'true'){
      $('button[name="add"]').text('Buy Now');
      $('div.pre_order_message').text('');
    }
    if(available == 'false' && preorder != 'true'){
      $('button[name="add"]').text('Sold out');
      $('div.pre_order_message').text('');
    }
    }, 500);

    if($('.swatch_pack_size').length >= 1){
      var price_quantity = parseInt($('.swatch_pack_size input[type="radio"]:checked').val());
    } else if($('.swatch_pack').length >= 1){
      var price_quantity = parseInt($('.swatch_pack input[type="radio"]:checked').val());
    } else {
      var price_quantity = 1;
    }
    if($('.prod_hide_unit').text() != '') {
      var unit_text = $('.prod_hide_unit').text();
    } else {
      var unit_text = 'PER UNIT';
    }
    var price_unit = $('.prod_hide_currency').text();
    if($('#appstle-subscription-widget-placeholder').length >= 1 || $('.prod_info_apphom').length >= 1){
      let inter_val = setInterval(function () {
        if($(".appstle_subscription_wrapper_option").length >= 1) {
          var price_box = $('.appstle_subscription_wrapper_option').not('.appstle_include_dropdown').find('.appstle_subscription_amount').text();
          price_box = price_box.replace(price_unit,'');
          var price_unitprice = parseFloat(price_box / price_quantity).toFixed(2) ;
          
          var price_subscript = $('.appstle_include_dropdown .appstle_subscription_amount').text();
          price_subscript = price_subscript.replace(price_unit,'');
          var price_subsunitprice = parseFloat(price_subscript / price_quantity).toFixed(2) ;
          $(".appstle_subscription_wrapper_option.appstle_include_dropdown").append('<ul class="appstle_lists"><li>Save 25% off your first order & 15% thereafter</li><li>Easily pause, swap or skip</li><li>Cancel quickly anytime</li><li>Daily ritual</li></ul>');
          $(".appstle_subscription_wrapper_option.appstle_include_dropdown").find('.appstle_subscription_amount_wrapper').append('<div class="appstle_perunit"><span>'+price_unit+''+price_subsunitprice+'</span>&nbsp;'+unit_text+'</div>');
          $(".appstle_subscription_wrapper_option").not('.appstle_include_dropdown').find('.appstle_one_time_price_wrapper').append('<div class="appstle_perunit"><span>'+price_unit+''+price_unitprice+'</span>&nbsp;'+unit_text+'</div>');
          clearInterval(inter_val);
        }
      }, 1000);
    }
  });

  // Change variant image
  $('input.product-form__swatch__input').change(function(){
    var prevariantid = getParameterByName('variant');
    var pregotoindex = $('select option[data-id="'+prevariantid+'"]').attr('data-image');
    setTimeout(function () {
        var variantid = getParameterByName('variant');
        var gotoindex = $('select option[data-id="'+variantid+'"]').attr('data-image');
        var gotoslide = $('div[data-media="'+gotoindex+'"]').attr('data-slick-index');
        if(pregotoindex != gotoindex){
          $('.mainprod_slider').slick('slickGoTo', gotoslide);
        }
    $('a.direct_checkout_buy_now').attr('href','https://aguademadre.myshopify.com/cart/clear?return_to=/cart/add?items[][id]='+variantid+'%26items[][quantity]=1%26return_to=/checkout');
    }, 500);
  });

  //Product Popups
  $('.prod_popup_click').on('click', function(e){
    e.preventDefault();
    var popup_open = $(this).attr('data-popup');
    $('body').addClass('no_scroll');
    $('#'+popup_open).removeClass('popup_box_hidden');
  });

  //Product Popups Close
  $('.popup_box .popup_close').on('click', function(e){
    e.preventDefault();
    var popup_open = $(this).attr('data-popup');
    $('body').removeClass('no_scroll');
    $(this).parents('.popup_box').addClass('popup_box_hidden');
  });
  
});

// =============================================================
// FREE GIFT CART DRAWER REFRESH
// Intercepts all fetch calls to /cart/add.js — including those
// made by Appstle for the free gift — then calls Cart.refresh()
// via window.__cartStore (exposed in cart-store.js) so the
// drawer re-renders with the gift item included.
// =============================================================
(function () {
  var _nativeFetch = window.fetch;
  var _refreshPending = false;

  function doRefresh() {
    if (_refreshPending) return;
    _refreshPending = true;
    setTimeout(function () {
      _refreshPending = false;
      if (window.__cartStore) {
        console.log('[Gift Refresh] Calling Cart.refresh()');
        window.__cartStore.refresh().catch(function (e) {
          console.warn('[Gift Refresh] refresh() failed:', e);
        });
      } else {
        console.warn('[Gift Refresh] window.__cartStore not available yet');
      }
    }, 1000);
  }

  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var result = _nativeFetch.apply(this, arguments);

    // Watch for ANY /cart/add.js call (theme or 3rd-party app)
    if (url.indexOf('/cart/add') !== -1) {
      result.then(function (response) {
        if (response.ok) {
          console.log('[Gift Refresh] /cart/add.js detected, scheduling refresh...');
          doRefresh();
        }
      }).catch(function () {});
    }

    return result;
  };
})();
